let initialized = false;

function initImageLightbox(){
    let lbNode: HTMLElement | null = null;
    if(!initialized){
        const html = `<div id="imgzoomlightbox" class="imgzoomlightbox" aria-hidden="true" role="dialog" tabindex="-1">
          <div class="imgzoomlightbox__content" role="document">
            <img src="" alt="Lightbox image" class="imgzoomlightbox__image" />
          </div>
        </div>`;

        lbNode = document.createElement<HTMLDivElement>('DIV');
        document.querySelector<HTMLBodyElement>('body')?.appendChild(lbNode);
        lbNode.outerHTML = html;
        initialized = true;
    }

    lbNode = document.querySelector<HTMLElement>('.imgzoomlightbox');


    return (imgNode: HTMLImageElement) => {

            const lightbox = lbNode;
            const img = lightbox.querySelector('.imgzoomlightbox__image');
            img.src = imgNode.src;
            lightbox.classList.add('active');
            lightbox.setAttribute('aria-hidden', 'false');
            lightbox.focus();

            function close(){
                lightbox.classList.remove('active');
                lightbox.setAttribute('aria-hidden', 'true');
                img.src = '';
                lightbox.removeEventListener('click', closeOnClick);
                document.removeEventListener('keydown', closeOnClick);
            }

            function closeOnClick(e) {
                if (e.target !== img) {
                    close();
                }
            }
            function closeOnEscape(e){
                if(e.key === 'Escape'){
                    close();
                }
            }

            lightbox.addEventListener('click', closeOnClick);
            document.addEventListener('keydown', closeOnEscape);


    };


}

export { initImageLightbox };